<template>
  <div class="module-list">
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Browsing the Market" partName="Purchasing Items">
          <div class="item-title">Market Display</div>
          <div class="item-summary">
            Items on the market are categorized into <strong>Recommended, Characters, Firearms, Melee Weapons, Gloves,
              Stickers, Cases, and more.</strong>
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/game1.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Browsing the Market" partName="Purchasing Items">
          <div class="item-title">Custom Filters</div>
          <div class="item-summary">
            Players can customize filters, including <strong>item category, quality, special features, and case
              ownership.</strong>
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/game2.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Browsing the Market" partName="Purchasing Items">
          <div class="item-title">Sorting Options</div>
          <div class="item-summary">
            Items can be sorted by <strong>time or price.</strong>
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/game3.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Browsing the Market" partName="Purchasing Items">
          <div class="item-title">Selecting Items</div>
          <div class="item-summary">
            Once an item is selected, clicking the <strong>BUY</strong> button will bring up a confirmation window to
            verify details such as the item description, price, and quantity.
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/game4.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="Viewing Item Details" partName="Purchasing Items">
          <div class="item-summary">
            <strong>Clicking on an item in the market will open its detailed display page. Using a weapon skin as an
              example:</strong>
          </div>
          <div class="item-summary">
            If the selected item is <strong>Weapon Skin A</strong>, the page will display a list of all <strong>Weapon
              Skin A</strong>
            listings available
            on the market. Information includes: Skin appearance, Item ID, Wear value, Stickers, Unit price (clickable
            for purchasing), Favorite (clickable to add to the favorites list).
          </div>
          <div class="item-summary">
            <strong>Trade Log:</strong> Clicking the <strong>Trade Log</strong> allows you to view the transaction
            history for a specific item.
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/game5.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part-container">
      <div class="left-info">
        <TitleWrap title="My Favorites" partName="Purchasing Items">
          <div class="item-summary">
            The <strong>My Favorites</strong> section displays items that players have marked as favorites. If a
            favorite item is removed from the market or sold, it will be automatically removed from the favorites list.
          </div>
        </TitleWrap>
      </div>
      <div class="right-content">
        <div class="swiper-outer">
          <svg-icon icon-class="playDetails_931_449_border" class-name="border-svg" />
          <div class="swiper-padding">
            <div class="img-wrap">
              <img src="@/assets/images/playDetails/InGame/game6.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleWrap from "../titleWrap";
export default {
  components: { TitleWrap },
  props: {},
  data() {
    return {}
  },
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>